<template>
  <v-data-table
    :headers="headers"
    :items="discussions"
    sort-by="discussions"
    class="elevation-1"
    :footer-props="{
      'items-per-page-text': 'Rivejä sivulla',
      'items-per-page-all-text': 'Kaikki',
    }"
  >
    <template v-slot:top>
      <v-alert :value="true" dense outlined type="error" v-if="error">
        {{ error }}
      </v-alert>
      <v-alert :value="true" dense outlined type="success" v-if="message">
        {{ message }}
      </v-alert>
      <v-toolbar flat>
        <v-toolbar-title>Keskustelut</v-toolbar-title>

        <v-spacer />
        <v-dialog v-model="dialog" max-width="750px">
          <v-card>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      label="Otsikko"
                      prepend-icon="mdi-account"
                      v-model="editDiscussions.discussionTitle"
                      autocomplete="off"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-textarea
                      label="Keskustelun kuvaus"
                      prepend-icon="mdi-information-variant"
                      v-model="editDiscussions.discussionDescription"
                      autocomplete="off"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      prepend-icon="mdi-account-supervisor"
                      v-model="editDiscussions.discussionOrganizationId"
                      :items="organizations"
                      label="Organisaatio"
                      placeholder="Organisaatio"
                      item-text="organizationName"
                      item-value="organizationId"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      prepend-icon="mdi-account-supervisor"
                      v-model="editDiscussions.discussionModerator"
                      :items="users"
                      label="Moderaattori"
                      placeholder="Moderaattori"
                      item-text="fullName"
                      item-value="uuid"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-autocomplete
                      prepend-icon="mdi-account-supervisor"
                      v-model="editDiscussions.discussionState"
                      :items="queryStates"
                      label="Keskustelun tila"
                      placeholder="Valitse..."
                      item-text="name"
                      item-value="value"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer />
              <v-btn color="blue darken-1" text @click="close">
                Peruuta
              </v-btn>
              <v-btn color="blue darken-1" text @click="save">
                Talleta
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <v-icon small class="mr-2" @click="editItem(item)">
        mdi-pencil
      </v-icon>
    </template>
    <template v-slot:[`item.results`]="{ item }">
      <v-icon small class="mr-2" @click="showResults(item)">
        mdi-pencil
      </v-icon>
    </template>
  </v-data-table>
</template>
<script>
import UserService from '@/services/UserService.js';
import OrganizationService from '@/services/OrganizationService.js';
import DiscussionService from '@/services/Tieto/DiscussionService.js';
export default {
  data() {
    return {
      discussions: [],
      users: [],
      organizations: [],
      dialog: false,
      error: null,
      message: null,

      headers: [
        { text: 'Otsikko', value: 'discussionTitle' },
        { text: 'Organisaatio', value: 'Organization.organizationName' },
        { text: 'Tila', value: 'discussionState' },
        {
          text: 'Muuta',
          value: 'actions',
          sortable: false,
        },
      ],
      queryStates: [
        { name: 'Aktiivinen', value: 'Aktiivinen' },
        {
          name: 'Passiivinen',
          value: 'Passiivinen',
        },
      ],
      editDiscussions: {
        discussionTitle: '',
        discussionDescription: '',
        discussionOrganizationId: '',
        discussionModerator: '',
      },
    };
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async created() {
    const discussions = await DiscussionService.getAllDiscussions();
    this.discussions = discussions.data.discussions;
    const organizations = await OrganizationService.getAllOrganizations();
    this.organizations = organizations.data.organizations;
  },

  methods: {
    async editItem(item) {
      const users = await UserService.getAllOrganizationUsers({
        organizationId: item.Organization.organizationId,
      });
      this.users = users.data.users;
      this.editDiscussions = Object.assign({}, item);
      this.dialog = true;
    },

    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editDiscussions = Object.assign({}, this.discussions);
      });
    },

    async save() {
      try {
        const response = await DiscussionService.saveDiscussionModification(
          this.editDiscussions
        );
        this.message = response.data.message;
        this.error = response.data.error;
        const discussions = await DiscussionService.getAllDiscussions();
        this.discussions = discussions.data.discussions;
        this.close();
        setTimeout(() => {
          this.message = null;
          this.error = null;
        }, 3000);
      } catch (error) {
        this.close();
        this.error = 'Jokin meni vikaan';
        setTimeout(() => {
          this.error = null;
        });
      }
    },
  },
};
</script>
<style></style>
